import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatterDocumentType } from '@models/matter-file';

@Component({
	selector: 'app-upload-manual-file-modal',
	templateUrl: './upload-file-modal.component.html',
	standalone: false,
})
export class ManualTitleInsuranceUploadFileComponent {
	@SelectSnapshot(SelectedMatter.id) matterId: string;
	public TLFileType = MatterDocumentType.TITLE_INSURANCE;

	constructor(
		private dialogRef: MatDialogRef<ManualTitleInsuranceUploadFileComponent>,
	) {}

	onUploadSuccess() {
		this.dialogRef.close();
	}
}
